import { Helmet } from "react-helmet";

import { PRIVATE_DATASETS_PATH } from "helpers/constants/paths";

import { isAnonymousUser, selectUser } from "redux/authReducer";
import { setShowMobileErrorModal } from "redux/Modals/actions";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  useWindowResize,
  isMobileDevice,
  isOnPremUser,
} from "helpers/utility/utilities";
import { composeApiURL } from "helpers/utility/axiosHelpers";

import styles from "./style.module.scss";
import OnPremLogin from "./OnPremLogin";
import { getIsUserManagementEnabled } from "redux/User/selectors";

const LoginButtons = () => {
  const generateSSOUrl = () => {
    return composeApiURL(process.env.REACT_APP_API_ENDPOINT!, "/oidc/login");
  };

  return (
    <div className={styles.loginButtons}>
      <div className={styles.loginButtonWrapper}>
        <a className={styles.loginButton} href={generateSSOUrl()}>
          <span>Log in with SSO</span>
        </a>
      </div>
    </div>
  );
};

const Login = () => {
  const { width } = useWindowResize();
  const dispatch = useDispatch();

  const isOnPrem = isOnPremUser();
  const isUserManagementEnabled = useSelector(getIsUserManagementEnabled);

  //REMOVE CONDITION WHEN TWEAKING WITHOUT TOKENS IS NOT NEEDED ANYMORE
  if (process.env.REACT_APP_IS_AUTHENTICATION_DISABELED === "false") {
    let user = selectUser();
    if (user && !isAnonymousUser()) {
      window.location.href = PRIVATE_DATASETS_PATH;
    }
  }

  useEffect(() => {
    if (localStorage.getItem("disclaimer-shown")) {
      return;
    }

    if (isMobileDevice()) {
      dispatch(setShowMobileErrorModal(true));
      localStorage.setItem("disclaimer-shown", "true");
    } else {
      dispatch(setShowMobileErrorModal(false));
    }
    // eslint-disable-next-line
  }, [width]);

  // Render OnPremLogin for air-gapped environments
  if (isOnPrem && isUserManagementEnabled) {
    return <OnPremLogin />;
  }

  // Render SSO login
  return (
    <div className={styles.loginContainer}>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <div className={styles.loginTitleContainer}>
        <div className={styles.loginTitle}>Get started</div>
        <div className={styles.loginDescription}>
          Sign in to enjoy the features of Visual Layer
        </div>
      </div>
      <LoginButtons />
      <div className={styles.agreeTerms}>
        By Signing In, I Agree To The{" "}
        <a
          href={"https://visual-layer2.readme.io/docs/terms-of-service"}
          target="_blank"
          rel="noreferrer"
          className={styles.link}
        >
          Terms And Conditions
        </a>{" "}
        And{" "}
        <a
          href={"https://visual-layer2.readme.io/docs/privacy-policy"}
          target="_blank"
          rel="noreferrer"
          className={styles.link}
        >
          The Privacy Policy
        </a>
      </div>
    </div>
  );
};

export default Login;
